import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "organisation-form-field" }
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = ["disabled"]

import { ref, onMounted } from "vue";
import axios from "axios";
import { Modal } from "uiv";
import { OrganisationDescriptionApiModel } from "../../../api-models";
import OrganisationPicker from "./organisation-picker.vue";
import OrganisationLabel from "./organisation-label.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'organisation-form-field',
  props: {
    name: {},
    initialValue: {},
    hideChangeButton: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const value = ref<OrganisationDescriptionApiModel | null>(null);

const visibleOrganisations = ref<OrganisationDescriptionApiModel[]>([]);

const selectedOrganisation = ref<OrganisationDescriptionApiModel | null>(null);

const errors = ref<string[]>([]);

const shown = ref(false);

function close(): void {
  shown.value = false;
}

function cancel(): void {
  close();
}

onMounted(async () => {
  try {
    visibleOrganisations.value = (await axios.get("/api/organisation")).data;
    if (props.initialValue) {
      value.value = visibleOrganisations.value.find((o) => o.id === props.initialValue) || null;
    }
  } catch (e) {
    errors.value = ["Failed to load organisations"];
  }
});

function openPicker(): void {
  selectedOrganisation.value = null;
  errors.value = [];
  shown.value = true;
}

function onSelectionChanged(newSelection: OrganisationDescriptionApiModel): void {
  selectedOrganisation.value = newSelection;
}

function updateSelection(): void {
  if (!selectedOrganisation.value) {
    return;
  }
  value.value = selectedOrganisation.value;
  close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (value.value)
      ? (_openBlock(), _createBlock(OrganisationLabel, {
          key: 0,
          value: value.value,
          emptyText: "Not selected"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      name: _ctx.name,
      value: value.value && value.value.id,
      type: "hidden"
    }, null, 8, _hoisted_2),
    (!_ctx.hideChangeButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          onClick: openPicker,
          class: "btn btn-link"
        }, "Change..."))
      : _createCommentVNode("", true),
    _createVNode(_unref(Modal), {
      class: "text-left",
      modelValue: shown.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shown).value = $event)),
      title: "Pick a new Organisation"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-lg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateSelection())),
            disabled: !selectedOrganisation.value
          }, " Change ", 8, _hoisted_9),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-default btn-lg",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (cancel()))
          }, "Cancel")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (shown.value)
                ? (_openBlock(), _createBlock(OrganisationPicker, {
                    key: 0,
                    organisations: visibleOrganisations.value,
                    selection: selectedOrganisation.value,
                    onSelectionChanged: onSelectionChanged
                  }, null, 8, ["organisations", "selection"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (errors.value && errors.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "col-sm-12 text-danger text-left",
                      key: error
                    }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})